import React from "react"
import {Form, Location} from "./parts"
import {ContactContainer} from "./styles"

export default function contact(){
    return (
        <ContactContainer>
            <Form/>
            <Location/>
        </ContactContainer>
    )
}
